module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.6.0 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/calendar.html"
    }
  }, [_vm._v("Calendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持显示弹窗头部(取消，确定)")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/checker.html"
    }
  }, [_vm._v("Checker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复 on-change 事件 在使用 :value 绑定的情况下不触发 #1945")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复取消文字、确认文字国际化显示问题")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/grid.html"
    }
  }, [_vm._v("Grid")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] rows 属性已经废弃，使用自动计算 #1971")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/inline-calendar.html"
    }
  }, [_vm._v("InlineCalendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] (beta) 支持属性 marks 用以自定义特定日期显示样式")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复星期文字 i18n")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/load-more.html"
    }
  }, [_vm._v("LoadMore")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复 `tip` 为空，且 `show-loading` 为 `false` 时背景颜色不对的问题 ")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持 @load-more-tip-background-color 全局设置文字背景颜色")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/panel.html"
    }
  }, [_vm._v("Panel")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 支持列表 fallbackSrc 属性在图片加载失败后显示 #1923")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popup-radio.html"
    }
  }, [_vm._v("PopupRadio")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复 placeholder 显示逻辑 #1964")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/swiper.html"
    }
  }, [_vm._v("Swiper")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 支持 list.fallbackImg 属性在图片加载失败时显示预设图片 #1923")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-dialog.html"
    }
  }, [_vm._v("XDialog")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复弹窗滑动时 body 区域依然会滚动的问题")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-img.html"
    }
  }, [_vm._v("XImg")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 当 src 变化时重新初始化 #1901")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e7cf4cde", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-e7cf4cde"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.6.0-253.vue
// module id = 2462
// module chunks = 264